<p-panelMenu [model]="menuItems" class="lp-menu w-full" />
